// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('ediImport', {
//         templateUrl: 'views/components/views/ediImport/ediImport.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'base64', 'translateService', 'modalService', 'ediImportService', function ($stateParams, stateService, utilityService, base64, translateService, modalService, ediImportService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let ediImportKeyno = $stateParams.edi_import_keyno;

//             let translations = {
//                 confirm_title: '',
//                 confirm_message: '',
//                 confirm_ok_label: '',
//                 confirm_cancel_label: '',
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 bgEdiImportMain: {
//                     selected: 'DETAILS',
//                     buttons: [
//                         { id: 'DETAILS', label: 'gb_ediimport_main_details', color: 'primary', onClick: () => vm.model.bgEdiImportMain.selected = 'DETAILS' },
//                         { id: 'CONTENT', label: 'gb_ediimport_main_content', color: 'primary', onClick: () => vm.model.bgEdiImportMain.selected = 'CONTENT' },
//                         { id: 'FUNCTIONS', label: 'gb_ediimport_main_functions', color: 'primary', onClick: () => vm.model.bgEdiImportMain.selected = 'FUNCTIONS' }
//                     ]
//                 },
//                 edit: {},
//                 itemsListEdiSources: [],
//                 itemsListImportProcesses: [],
//                 processing: false,
//                 lockedSave: false,
//                 lockedDelete: false,
//                 show_in_excelimport: 'A'
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE CALLS
            
//             async function loadEdit() {
//                 const response = (await ediImportService.getEdit({ edi_import_keyno: ediImportKeyno }))[0];
//                 vm.model.edit = response;
//                 vm.model.edit.filecontent = base64.urldecode(response.filecontent);
//             }

//             async function loadEdiSources() {
//                 vm.model.itemsListEdiSources = await ediImportService.listEdiSources();
//             }

//             async function loadImportProcesses() {
//                 if (utilityService.validateParmsValue(vm.model.show_in_excelimport) !== true) return;

//                 return vm.model.itemsListImportProcesses = await ediImportService.listImportProcesses({ show_in_excelimport: vm.model.show_in_excelimport });
//             }

//             // #endregion LOAD PROCEDURE CALLS

//             // #region PROCESS BUTTON FUNCTION
            
//             vm.processEdiImport = function () {
//                 vm.model.processing = true;
                
//                 ediImportService.processEdiImport({ edi_import_keyno: vm.model.edit.edi_import_keyno }).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                         modalService.show({
//                             type: 'warning',
//                             title: translations.error,
//                             message: response[0].errormessage,
//                             buttons: [{
//                                 label: translations.ok,
//                                 cssClass: 'btn-warning',
//                                 action: function (dialogItself) {
//                                     dialogItself.close();
//                                     vm.model.processing = false;
//                                     loadEdit();
//                                 }
//                             }]
//                         });
//                     } else {
//                         vm.model.processing = false;
//                         loadEdit();
//                     }
//                 });
//             }

//             // #endregion PROCESS BUTTON FUNCTION

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;
                
//                 ediImportService.saveObj({
//                     edi_import_keyno: vm.model.edit.edi_import_keyno,
//                     reg_datetime: vm.model.edit.reg_datetime,
//                     edi_source_keyno: vm.model.edit.edi_source_keyno,
//                     filename: vm.model.edit.filename,
//                     filecontent: base64.urlencode(vm.model.edit.filecontent),
//                     file_created_datetime: vm.model.edit.file_created_datetime,
//                     edi_prosess_status_name: vm.model.edit.edi_prosess_status_name,
//                     prosessing_start_datetime: vm.model.edit.prosessing_start_datetime,
//                     prosessing_end_datetime: vm.model.edit.prosessing_end_datetime,
//                     p2_importproc_keyno: vm.model.edit.p2_importproc_keyno,
//                     prosessing_message: vm.model.edit.prosessing_message,
//                     reg_by_portal_user_name: vm.model.edit.reg_by_portal_user_name,
//                     prosessing_count: vm.model.edit.prosessing_count,
//                     add_type: vm.model.edit.add_type
//                 }).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                         modalService.show({
//                             type: 'warning',
//                             title: translations.error,
//                             message: response[0].errormessage,
//                             buttons: [{
//                                 label: translations.ok,
//                                 cssClass: 'btn-warning',
//                                 action: function (dialogItself) {
//                                     dialogItself.close();
//                                     vm.model.lockedSave = false;
//                                 }
//                             }]
//                         });
//                     } else {
//                         vm.model.lockedSave = false;
//                         stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//             vm.deleteValues = function () {
//                 vm.model.lockedDelete = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     ediImportService.deleteItem({ edi_import_keyno: vm.model.edit.edi_import_keyno }).then(function (response) {
//                         if (response[0].errorcode !== '0') {
//                         	modalService.show({
//                         		type: 'warning',
//                         		title: translations.error,
//                         		message: response[0].errormessage,
//                         		buttons: [{
//                         			label: translations.ok,
//                         			cssClass: 'btn-warning',
//                         			action: function (dialogItself) {
//                         				dialogItself.close();
//                         				vm.model.lockedDelete = false;
//                         			}
//                         		}]
//                         	});
//                         } else {
//                         	vm.model.lockedDelete = false;
//                         	stateService.back();
//                         }
//                     }, function () {
//                         vm.model.lockedDelete = false;
//                     });
//                 }, function () {
//                     vm.model.lockedDelete = false;
//                 });
//             }

//             // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//             // #region BUTTON GROUP SINGLE FUNCTION

//             vm.selectBgEdiImportMain = function (value) {
//                 vm.model.bgEdiImportMain.selected = value;
//             }

//             // #endregion BUTTON GROUP SINGLE FUNCTION

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadEdiSources();
//                 loadImportProcesses();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
